'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _el_GR = require('../locale/el_GR');

var _el_GR2 = _interopRequireDefault(_el_GR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _el_GR2['default'];